import { Component, ComponentRef, ViewChild } from '@angular/core';

import {
  BasePortalHost,
  ComponentPortal,
  PortalHostDirective,
  TemplatePortal,
} from '../../core/core.module';

@Component({
  selector: 'rt-notifications-group',
  template: ` <ng-template portalHost></ng-template> `,
  styleUrls: ['./notifications-group.component.less'],
})
export class NotificationsGroupComponent extends BasePortalHost {
  @ViewChild(PortalHostDirective, { static: true }) public _portalHost: PortalHostDirective;

  public attachTemplatePortal(portal: TemplatePortal, index: number = 0): Map<string, any> {
    return this._portalHost.attachTemplatePortal(portal, index);
  }

  public attachComponentPortal<T>(portal: ComponentPortal<T>, index: number = 0): ComponentRef<T> {
    return this._portalHost.attachComponentPortal(portal, index);
  }
}
